module.exports = __webpack_public_path__ + "static/media/ott-icon.64a3d3d3.svg";